import { LessonDataI } from "@/components/quiz/typesAndEnums";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { LessonScreenContentI, LessonScreenI } from "@/hooks/types";

const LessonNavigationTabs = ({
  children,
  lessonData,
  screenContent,
  setScreenContent,
}: {
  children: any;
  lessonData: LessonDataI;
  screenContent: LessonScreenI;
  setScreenContent: ({ elementId, screen }: LessonScreenI) => void;
}) => {
  const videoDisbled =
    lessonData.quiz_required && lessonData.past_quiz_trials === null;
  return (
    <Tabs defaultValue={screenContent.screen} className="space-y-6 mx-4">
      <TabsList className="w-full flex flex-row-reverse justify-between items-center border border-slate-300 ">
        <TabsTrigger
          className="font-semibold"
          value={LessonScreenContentI.QUIZ}
          onClick={() => {
            setScreenContent({
              elementId: "",
              screen: LessonScreenContentI.QUIZ,
            });
          }}
        >
          إمتحان
        </TabsTrigger>
        <TabsTrigger
          className="font-semibold"
          value={LessonScreenContentI.VIDEO}
          disabled={videoDisbled}
          onClick={() => {
            setScreenContent({
              elementId: "",
              screen: LessonScreenContentI.VIDEO,
            });
          }}
        >
          {videoDisbled ? "فيديو ( يجب حل الإمتحان )" : "فيديو"}
        </TabsTrigger>
        <TabsTrigger
          className="font-semibold"
          value={LessonScreenContentI.HW}
          onClick={() => {
            setScreenContent({
              elementId: "",
              screen: LessonScreenContentI.HW,
            });
          }}
        >
          واجب
        </TabsTrigger>
        <TabsTrigger
          className="font-semibold"
          value={LessonScreenContentI.FILES}
          onClick={() => {
            setScreenContent({
              elementId: "",
              screen: LessonScreenContentI.FILES,
            });
          }}
        >
          ملفات
        </TabsTrigger>
      </TabsList>
      {children}
    </Tabs>
  );
};

export default LessonNavigationTabs;
